import { createGlobalStyle, css } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const DropdownStyles = createGlobalStyle`
  .ant-dropdown-menu,
  .ant-dropdown,
  .ant-menu {
    border-radius: 0 !important;

    button:not(.ant-menu-root > button):not([role="switch"]) {
      background-color: unset;
      border: none;
    }

    .ant-menu-item {
      &:hover,
      &:active {
        background-color: ${({ theme }) => theme.activeMenuItemBackgroundColor} !important;
      }
    }

    ${({ theme }) =>
      theme.themeName === Theme.Dark
        ? css`
            background-color: ${theme.tertiaryBackgroundColor} !important;

            &.ant-menu-vertical {
              border-right: unset;
            }

            .ant-menu-item-group-title,
            .ant-dropdown-menu-item-group-title {
              color: ${theme.disabledTextColor} !important;
            }

            .ant-dropdown-menu-item,
            .ant-menu-item {
              color: ${theme.headerColor} !important;

              &.ant-menu-item-disabled,
              &.ant-dropdown-menu-item-disabled {
                color: ${theme.disabledTextColor} !important;

                span {
                  color: ${theme.disabledTextColor} !important;
                }

                &:hover,
                &:active {
                  background-color: unset !important;
                }
              }

              &.ant-menu-item-selected {
                background-color: unset;
              }
            }

            .ant-dropdown-menu-item-divider {
              background-color: ${theme.borderColor} !important;
            }
          `
        : ''}
  }
`;
